import React from "react";
import { Paper, Typography, Tooltip, IconButton } from "@material-ui/core";
import { withStyles } from '@material-ui/core';
import { MTableToolbar } from 'material-table';
import {useSelector} from "react-redux";

const styles = theme => ({
    selectedActions: {
        display: 'flex',
        flex: '1 1 auto',
        color: theme.palette.text.secondary
    },
    selectedRoot: {
        backgroundColor: theme.palette.background.default,
        flex: '1 1 99%',
        display: 'flex',
        height: '65px',
        position: 'sticky',
        zIndex: 120,
        justifyContent: 'space-between'
    },
    selectedTitle: {
        paddingLeft: '26px',
        top: '50%',
        position: 'relative',
        transform: 'translateY(-50%)'
    },
    toolbar: {
        marginTop: '7px'
    }
});

const Toolbar = props => {
    const { classes, actions, translations, selectedRows, data, editable} = props;

    const checkedRowsFromStore = useSelector((state) => state?.raspberryEraseStation?.checkedRows?? []);

    let filteredRows = selectedRows.filter(row => {
        return !row.tableData.disabled && !checkedRowsFromStore?.includes(row.tableData.id);
    });

    const newData = { ...data, selectedRows: filteredRows };
    return (
        <div className={classes.toolbar}>
            {
                filteredRows.length < 1 ? <MTableToolbar {...newData} />
                    :
                    <Paper className={classes.selectedRoot}>
                        <div>
                            <Typography variant="subtitle1" className={classes.selectedTitle}>
                                {filteredRows.length}&nbsp;{translations['row_selected'] || 'row(s) selected'}
                            </Typography>
                        </div>
                        <div className={classes.spacer} />
                        <div className={classes.selectedActions}>
                            {
                                actions.map(action => {
                                    return (
                                        <Tooltip key={`${action.tooltip}`} title={action.tooltip}>
                                            <IconButton
                                                component="div"
                                                disabled={editable}
                                                key={`${action.tooltip}`}
                                                aria-label={action.tooltip}
                                                onClick={() => action.onClick(filteredRows)}
                                            >
                                                {action.icon}
                                            </IconButton>
                                        </Tooltip>
                                    )
                                })
                            }
                        </div>
                    </Paper>
            }
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(Toolbar);


